
import { defineComponent } from 'vue';
import { Button } from 'ant-design-vue';
import sceneDesignMainHeader from '@/components/teacher/sceneConstruct/sceneDesignMainHeader.vue';

const component = defineComponent({
  name: 'task-list',
  components: {
    sceneDesignMainHeader,
    aButton: Button,
  },
  props: {
    headerText: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    function nextStep() {
      context.emit('nextStep');
    }
    return { props, nextStep };
  },
});

export default component;
